<template>
  <section class="notice-list-section">
    <div class="notice-list-section__container">
      <h2 class="notice-list-section__title">お知らせ</h2>
      <ul class="notice-list-section__list">
        <li
          v-for="notice in notices"
          :key="notice.id"
          class="notice-list-section__item"
        >
          <a
            :href="notice.url"
            class="notice-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span v-if="notice.date" class="notice-link__date">
              {{ notice.date }}
            </span>
            <span class="notice-link__title">{{ notice.title }}</span>
            <ChevronForward class="notice-link__chevron" />
          </a>
        </li>
      </ul>
    </div>
  </section>
</template>
<script setup>
import ChevronForward from '../../../atoms/svg_icons/ChevronForward.vue'

const notices = [
  {
    id: 1,
    date: '10/21',
    title:
      '【重要】システムメンテナンスに伴う一部商品の販売・利用一時停止のお知らせ',
    url: 'https://giftee.com/announcements/772'
  },
  {
    id: 2,
    date: '10/21',
    title: '「ご利用ガイド」と「よくあるご質問」利用一時停止のお知らせ',
    url: 'https://giftee.com/announcements/771'
  }
]
</script>
<style lang="scss" scoped>
.notice-list-section {
  @extend %top-section;

  &__container {
    @extend %top-section__container;
    padding-bottom: 0;
  }

  &__title {
    @extend %top-section__title;
    padding: 8px 0;
  }

  &__list {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  &__item + &__item {
    border-top: 1px solid $gray-2;
  }
}

.notice-link {
  display: flex;
  align-items: center;
  gap: 8px;
  box-sizing: border-box;
  min-height: 56px;
  padding: 16px 0;
  font-size: 14px;
  line-height: 1.6;
  letter-spacing: 0.02em;
  color: $black;
  text-decoration: none;

  &__date {
    flex-shrink: 0;
  }

  &__title {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  &__chevron {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    fill: $black;
  }
}
</style>
